export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4607.4309d43b.jpg";